import React, { ReactElement, useState } from 'react'
import parse from 'html-react-parser'
import { StyledPreview } from '../styled-components'

import { StyledIcon } from '../../../../styled-components'

import Icon from '../../../../../../components/icon'
import { useAddTextAdminContext } from '../../../../../../contexts/add-text-admin'

const Preview = (): ReactElement => {
  const [mobilePreview, setMobilePreview] = useState(false)
  const { addTextAdmin } = useAddTextAdminContext()

  return (
    <StyledPreview mobilePreview={mobilePreview}>
      <StyledIcon onClick={() => setMobilePreview(!mobilePreview)}>
        <Icon
          name={
            mobilePreview ? 'ant-design:desktop-outlined' : 'radix-icons:mobile'
          }
          color="darkRed"
          width={20}
          height={20}
        />
      </StyledIcon>
      {addTextAdmin.map((section) => (
        <>{parse(section.value)}</>
      ))}
    </StyledPreview>
  )
}

export default Preview
